import PropTypes from 'prop-types';
import { BsJournalText } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';

const CompanyBusinessPurpose = ({ businessPurpose }) => (
	<SectionCard title="Gegenstand" icon={BsJournalText}>
		<p className="whitespace-pre-line text-sm leading-relaxed text-text">{businessPurpose}</p>
	</SectionCard>
);

CompanyBusinessPurpose.propTypes = {
	businessPurpose: PropTypes.string.isRequired,
};

export default CompanyBusinessPurpose;
